import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';

function ChemquoteExportModalHeader({ close }) {
  const closeLabel = 'Close export modal';

  return (
    <div className="exportModal__header">
      <h3 className="u-els-font-size-h3 u-els-line-height-single">Export substances ChemQuote</h3>
      <ButtonWithIcon
        data-e2e="export-modal-close"
        type="link"
        size="small"
        sprite="Close"
        iconOnly
        aria-label={closeLabel}
        onClick={close}>
        {closeLabel}
      </ButtonWithIcon>
    </div>
  );
}

ChemquoteExportModalHeader.propTypes = {
  close: PropTypes.func,
};

export default ChemquoteExportModalHeader;
